import React from 'react'
import useScrollReveal from '../../hooks/useScrollReveal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faRobot } from '@fortawesome/free-solid-svg-icons'

const CHAT_MESSAGES = [
  {
    role: 'user',
    text: 'Quel est mon solde total sur tous mes comptes ?',
  },
  {
    role: 'ai',
    text: "Votre patrimoine total s\u2019\u00e9l\u00e8ve \u00e0 12\u00a0450,00\u00a0\u20ac r\u00e9partis sur 4 comptes. Votre Livret A repr\u00e9sente 67% de votre \u00e9pargne.",
  },
  {
    role: 'user',
    text: "Combien ai-je d\u00e9pens\u00e9 en alimentation ce mois-ci ?",
  },
  {
    role: 'ai',
    text: "Vous avez d\u00e9pens\u00e9 342,80\u00a0\u20ac en alimentation ce mois-ci, soit 15% de moins que le mois dernier. Vous \u00eates dans les clous de votre budget.",
  },
]

export default function AiMcp() {
  const [ref, isVisible] = useScrollReveal()

  return (
    <section id="ai" className={`section-padding reveal${isVisible ? ' revealed' : ''}`} ref={ref}>
      <h2 className="section-title">Parlez à vos finances.</h2>
      <p className="section-subtitle">Grâce au protocole MCP, connectez votre assistant IA directement à vos comptes.</p>

      <div className="landing-ai">
        <div className="landing-ai__chat">
          {CHAT_MESSAGES.map((msg, i) => (
            <div className={`landing-ai__message landing-ai__message--${msg.role}`} key={i}>
              {msg.role === 'ai' && (
                <div className="landing-ai__message-avatar">
                  <FontAwesomeIcon icon={faRobot} />
                </div>
              )}
              <div className="landing-ai__message-bubble">
                {msg.text}
              </div>
              {msg.role === 'user' && (
                <div className="landing-ai__message-avatar">
                  <FontAwesomeIcon icon={faUser} />
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="landing-ai__badges">
          <span className="landing-ai__badge landing-ai__badge--highlight">40+ outils disponibles</span>
          <span className="landing-ai__badge">Compatible Claude, GPT, Gemini</span>
          <span className="landing-ai__badge landing-ai__badge--soon">Bientôt disponible</span>
        </div>
      </div>
    </section>
  )
}
